<template>
  <div>
    <ContenedorCollapsable
      idCollapsable="ubicacion"
      tituloColapsable="¿Qué instituciones la imparten, en qué lugares y cuál es su arancel?"
    >
      <div class="kpis col-12 col-md-11 mx-auto mt-2 pb-4 px-0">
        <h3 class="subtt text-azul-medio w-100 text-center my-3">
          instituciones, regiones y arancel
        </h3>

        <div class="ventana d-md-flex">
          <!-- scroll -->

          <div class="col-md-5 sel1">
            <div class="row w-100 offset-md-1 d-inline-flex">
              <h6 class="d-block d-md-none">{{ carrera1.carreraGenerica }}</h6>
              <ul
                class="w-100 px-0"
                v-for="regionArancel1 in carrera1.regionesArancel"
                :key="regionArancel1.index"
              >
                <li>
                  <div class="col-7 px-0">
                    <dt>{{ regionArancel1.institucion }}</dt>
                    <dd>{{ formatearRegion(regionArancel1.region) }}</dd>
                  </div>

                  <div class="col px-0 pl-3">
                    <dt>Arancel:</dt>
                    <dd>{{ validarArancel(regionArancel1.arancel) }}</dd>
                  </div>
                </li>
              </ul>
            </div>
          </div>

          <div class="col-md-2 icos text-center px-2">
            <img
              class="small-ic align-self-center"
              style="width: 3rem"
              src="@/assets/img/iconos/comparador-7.svg"
              alt="mapa Chile"
            />
          </div>

          <div class="col-md-5 sel2">
            <div class="row w-100 d-inline-flex">
              <h6 class="d-block d-md-none">
                {{ carrera2.carreraGenerica }}
              </h6>
              <ul
                class="w-100 px-0"
                v-for="regionArancel2 in carrera2.regionesArancel"
                :key="regionArancel2.index"
              >
                <li>
                  <div class="col-7 px-0">
                    <dt>{{ regionArancel2.institucion }}</dt>
                    <dd>
                      {{ formatearRegion(regionArancel2.region) }}
                    </dd>
                  </div>
                  <div class="col px-0 pl-3">
                    <dt>Arancel:</dt>
                    <dd>{{ validarArancel(regionArancel2.arancel) }}</dd>
                  </div>
                </li>
              </ul>
            </div>
          </div>
        </div>
      </div>
    </ContenedorCollapsable>
  </div>
</template>

<script>
import ContenedorCollapsable from "@/components/comparadorITP/ContenedorCollapsable";
import FormatoMonetario from "@/utils/FormatoMonetario.js";
import Busqueda from "@/utils/Busqueda.js";

export default {
  name: "UbicacionCollapse",
  components: {
    ContenedorCollapsable
  },
  props: {
    carrera1: { type: Object },
    carrera2: { type: Object }
  },
  methods: {
    validarArancel(valor) {
      return valor != 0
        ? this.formatoMoneda(valor)
        : "INFORMACIÓN NO DISPONIBLE";
    },
    reducirPadding(valor) {
      return valor != 0 ? "cont col" : "cont";
    },
    formatoMoneda(value) {
      return FormatoMonetario.getMontoEnMoneda(value);
    },
    formatearRegion(value) {
      return Busqueda.limpiarNombreRegionSimble(value);
    }
  }
};
</script>

<style></style>



// WEBPACK FOOTER //
// src/components/comparadorITP/UbicacionCollapse.vue